'use client';

import { c as _c } from "react/compiler-runtime";
import { Modal } from '@7f-ui/components/modal/modal';
import { useToast } from '@7f-ui/components/toast/toast-provider';
import type { CartItemExperienceFragment } from '@data-access/lib/gql/cart/documents';
import { useCartItem } from '@feat/feat-cart/item';
import { useState } from 'react';
import type { PurchasableDay } from '../../erlebnisse/ticket-flow';
import { AppPersonModalContent, AppTicketDatePickerContent, AppTicketSelectionContent, ExperienceFilterProvider, useAppExperienceVisitDay, useExperienceFilterContext, useExperienceOptions } from '../../erlebnisse/ticket-flow';
enum ModalType {
  Selection = 'Selection',
  Tickets = 'Tickets',
  Date = 'Date',
}
type AppCartItemTicketModalProps = {
  item: CartItemExperienceFragment;
  onClose: VoidFunction;
};
export function AppCartItemTicketModal(t0) {
  const $ = _c(12);
  const {
    item,
    onClose
  } = t0;
  const {
    variants
  } = item.experience;
  const {
    getSelectedOptions
  } = useExperienceOptions(variants);
  let t1;
  if ($[0] !== getSelectedOptions || $[1] !== item.tickets) {
    t1 = getSelectedOptions(item.tickets);
    $[0] = getSelectedOptions;
    $[1] = item.tickets;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== item.variantId || $[4] !== t1) {
    t2 = {
      selectedOptions: t1,
      selectedVariant: item.variantId
    };
    $[3] = item.variantId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const initialFilter = t2;
  let t3;
  if ($[6] !== initialFilter || $[7] !== item) {
    t3 = t4 => {
      const {
        onClose: closeModal,
        setActiveContent,
        activeContent
      } = t4;
      return <ExperienceFilterProvider experience={item.experience} initialFilter={initialFilter}><TicketSlides item={item} activeContent={activeContent} setActiveContent={setActiveContent} onClose={closeModal} title={item.experience.title} ticketsTitle="Wer kommt mit?" dateTitle={"Datum w\xE4hlen"} /></ExperienceFilterProvider>;
    };
    $[6] = initialFilter;
    $[7] = item;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onClose || $[10] !== t3) {
    t4 = <Modal isOpen={true} onClose={onClose} initialContent={ModalType.Selection}>{t3}</Modal>;
    $[9] = onClose;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
type TicketSlidesProps = {
  item: CartItemExperienceFragment;
  activeContent: string | undefined;
  setActiveContent: (name: string) => void;
  onClose: VoidFunction;
  title: string;
  ticketsTitle: string;
  dateTitle: string;
};
function TicketSlides(t0) {
  const $ = _c(51);
  const {
    item,
    activeContent,
    setActiveContent,
    onClose,
    title,
    ticketsTitle,
    dateTitle
  } = t0;
  const toast = useToast();
  const {
    experience,
    filter
  } = useExperienceFilterContext();
  const {
    updateExperience
  } = useCartItem();
  const {
    visitDay,
    isLoading: isVisitDayLoading
  } = useAppExperienceVisitDay(experience.publicId, item.visitDate);
  const [selectedDay, setSelectedDay] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const day = selectedDay ?? visitDay;
  const needsVisitDate = !experience.alwaysAvailable && !day;
  let t1;
  if ($[0] !== day?.date || $[1] !== experience.id || $[2] !== filter.selectedOptions || $[3] !== item.id || $[4] !== needsVisitDate || $[5] !== onClose || $[6] !== toast || $[7] !== updateExperience) {
    t1 = () => {
      if (!filter.selectedOptions || needsVisitDate) {
        return;
      }
      setIsSubmitting(true);
      updateExperience(item.id, {
        experienceId: experience.id,
        visitDate: day?.date ?? null,
        selectedOptions: filter.selectedOptions
      }, {
        onSuccess: () => {
          toast({
            type: "success",
            message: "Deine Auswahl wurde angepasst"
          });
          setIsSubmitting(false);
          onClose();
        },
        onError: () => {
          toast({
            type: "error",
            message: "Die \xC4nderung konnte nicht gespeichert werden. Bitte versuche es erneut."
          });
          setIsSubmitting(false);
        }
      });
    };
    $[0] = day?.date;
    $[1] = experience.id;
    $[2] = filter.selectedOptions;
    $[3] = item.id;
    $[4] = needsVisitDate;
    $[5] = onClose;
    $[6] = toast;
    $[7] = updateExperience;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleSubmit = t1;
  const t2 = needsVisitDate || isVisitDayLoading;
  const t3 = !experience.alwaysAvailable;
  let t4;
  let t5;
  if ($[9] !== setActiveContent) {
    t4 = () => setActiveContent(ModalType.Tickets);
    t5 = () => setActiveContent(ModalType.Date);
    $[9] = setActiveContent;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  let t6;
  if ($[12] !== day || $[13] !== handleSubmit || $[14] !== isSubmitting || $[15] !== isVisitDayLoading || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t6 = <AppTicketSelectionContent day={day} submitLabel={"\xDCbernehmen"} isSubmitting={isSubmitting} disabled={t2} showDateRow={t3} isDateLoading={isVisitDayLoading} onEditTickets={t4} onEditDate={t5} onSubmit={handleSubmit} />;
    $[12] = day;
    $[13] = handleSubmit;
    $[14] = isSubmitting;
    $[15] = isVisitDayLoading;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t6 || $[22] !== title) {
    t7 = {
      name: ModalType.Selection,
      title,
      children: t6
    };
    $[21] = t6;
    $[22] = title;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== setActiveContent) {
    t8 = () => setActiveContent(ModalType.Selection);
    $[24] = setActiveContent;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== setActiveContent) {
    t9 = <AppPersonModalContent showContactFormLink={false} onSubmit={() => setActiveContent(ModalType.Selection)} />;
    $[26] = setActiveContent;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t8 || $[29] !== t9 || $[30] !== ticketsTitle) {
    t10 = {
      name: ModalType.Tickets,
      title: ticketsTitle,
      onBackClick: t8,
      children: t9
    };
    $[28] = t8;
    $[29] = t9;
    $[30] = ticketsTitle;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== setActiveContent) {
    t11 = () => setActiveContent(ModalType.Selection);
    $[32] = setActiveContent;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const t12 = activeContent === ModalType.Date;
  let t13;
  if ($[34] !== day || $[35] !== handleSubmit || $[36] !== isSubmitting || $[37] !== t12) {
    t13 = <AppTicketDatePickerContent isActive={t12} selectedDay={day} submitLabel={"\xDCbernehmen"} isSubmitting={isSubmitting} onSelect={setSelectedDay} onSubmit={handleSubmit} />;
    $[34] = day;
    $[35] = handleSubmit;
    $[36] = isSubmitting;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== dateTitle || $[40] !== t11 || $[41] !== t13) {
    t14 = {
      name: ModalType.Date,
      title: dateTitle,
      onBackClick: t11,
      children: t13
    };
    $[39] = dateTitle;
    $[40] = t11;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t10 || $[44] !== t14 || $[45] !== t7) {
    t15 = [t7, t10, t14];
    $[43] = t10;
    $[44] = t14;
    $[45] = t7;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  const slides = t15;
  let t16;
  if ($[47] !== activeContent || $[48] !== onClose || $[49] !== slides) {
    t16 = <Modal.Slides activeContent={activeContent} onClose={onClose} slides={slides} />;
    $[47] = activeContent;
    $[48] = onClose;
    $[49] = slides;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  return t16;
}